import React, {ReactNode, useState} from 'react'
import {SKILL_SUMMARIZATION, SUMMARIZATION_SKILLS} from '../constants/skills'
import {ServiceGroup, SkillDescription} from '../dataModels/Service'

export interface contextProps<T> {
  skill: SkillDescription
  skillGroup: ServiceGroup
  skillExamples: T[]
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  isToxic: boolean
  setIsToxic: (isLoading: boolean) => void
}

interface Props<T> {
  skill: SkillDescription
  skillGroup: ServiceGroup
  skillExamples: T[]
  children: ReactNode
}

export const SkillContext = React.createContext<contextProps<any>>({
  skill: SKILL_SUMMARIZATION,
  skillGroup: SUMMARIZATION_SKILLS,
  skillExamples: [],
  isLoading: false,
  isToxic: false,
  setIsLoading(isLoading: boolean): void {},
  setIsToxic(isLoading: boolean): void {},
})

export function SkillProvider<T extends object>({
  skill,
  skillGroup,
  skillExamples,
  children,
}: Props<T>) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isToxic, setIsToxic] = useState<boolean>(false)

  return (
    <SkillContext.Provider
      value={{
        skill,
        skillGroup,
        skillExamples,
        isLoading,
        setIsLoading,
        isToxic,
        setIsToxic,
      }}>
      {children}
    </SkillContext.Provider>
  )
}
